import React from 'react';
import { rankingTileNewPropTypes } from './RankingTileNewPropTypes';
import RatingStars from '@App/common/components/RatingStars/RatingStars';
import Details from './components/Details/Details';
import ContentV1 from './components/ContentV1/ContentV1';
import ContentV2 from './components/ContentV2/ContentV2';
import * as styles from './RankingTileNew.module.scss';
const RankingTileNew = ({
  label,
  labelColor,
  heading,
  score,
  scoreText,
  picture,
  description,
  descriptionHeading,
  buttonHeading,
  buttons,
  accordion,
  productId,
  classname,
  variant,
  ...rest
}) => /*#__PURE__*/React.createElement("div", Object.assign({
  className: `${styles.root} ${classname || ''}`,
  "data-product-id": productId
}, rest), /*#__PURE__*/React.createElement("div", {
  className: styles.rootContainer
}, /*#__PURE__*/React.createElement("div", {
  className: styles.rootMain
}, label && /*#__PURE__*/React.createElement("div", {
  className: styles.rootLabel,
  style: {
    background: labelColor ? labelColor : null
  }
}, label), heading && /*#__PURE__*/React.createElement("h3", {
  className: styles.rootHeading
}, /*#__PURE__*/React.createElement("a", {
  className: styles.rootHeadingLink,
  href: buttons[0].href,
  target: "_blank",
  rel: "noopener noreferrer"
}, heading)), score && /*#__PURE__*/React.createElement("div", {
  className: styles.rootScore
}, /*#__PURE__*/React.createElement("span", {
  className: styles.rootScoreValue
}, score.toFixed(1)), /*#__PURE__*/React.createElement(RatingStars, {
  score: score,
  classname: styles.rootScoreStars
}), scoreText && /*#__PURE__*/React.createElement("span", {
  className: styles.rootScoreText
}, scoreText)), variant == 'v1' && /*#__PURE__*/React.createElement(ContentV1, {
  buttonHeading: buttonHeading,
  description: description,
  picture: picture,
  buttons: buttons
}), variant == 'v2' && /*#__PURE__*/React.createElement(ContentV2, {
  buttonHeading: buttonHeading,
  picture: picture,
  buttons: buttons
})), variant == 'v2' && descriptionHeading && /*#__PURE__*/React.createElement(Details, {
  label: "Szczeg\xF3\u0142y produktu",
  richtext: description
}), accordion === null || accordion === void 0 ? void 0 : accordion.map(({
  label,
  richtext
}, index) => /*#__PURE__*/React.createElement(Details, {
  label: label,
  richtext: richtext,
  key: index
}))));
export default RankingTileNew;